import React__default from 'react';
import classNames from 'classnames';
import OutlineClose from '../icons/generated/outline/OutlineClose.js';
import Text from '../Text/index.js';
import useToast from './hook.js';
var Toast = function Toast(_ref) {
  var text = _ref.text,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "success" : _ref$type,
    isVisible = _ref.isVisible,
    close = _ref.close;
  var _useToast = useToast(),
    icons = _useToast.icons;
  var Icon = icons[type];
  var classes = classNames("iq-toast", {
    "iq-toast--visible": isVisible,
    "iq-toast--success": type === "success",
    "iq-toast--info": type === "info",
    "iq-toast--error": type === "error",
    "iq-toast--warning": type === "warning"
  });
  return /* @__PURE__ */React__default.createElement("div", {
    className: classes,
    role: "alert"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "iq-toast__icon"
  }, /* @__PURE__ */React__default.createElement(Icon, null)), /* @__PURE__ */React__default.createElement("div", {
    className: "iq-toast__content"
  }, /* @__PURE__ */React__default.createElement(Text, {
    as: "p",
    variant: "body-small",
    className: "iq-toast__content-message"
  }, text), /* @__PURE__ */React__default.createElement("button", {
    className: "iq-toast__content-button",
    onClick: close,
    "aria-label": "Fechar alerta"
  }, /* @__PURE__ */React__default.createElement(OutlineClose, null))));
};
export { Toast as default };